window.addEventListener( 'load', function() {
	
	const slider = new KeenSlider('.wp-block-hoyry-logo-carousel .keen-slider', {
		loop: true,
		renderMode: 'precision',
		slides: {
			perView: 6,
		},
		breakpoints: {
			"(max-width: 1599px)": {
				slides: {
					perView: 5,
				}
			},
			"(max-width: 1279px)": {
				slides: {
					perView: 4,
				}
			},
			"(max-width: 1023px)": {
				slides: {
					perView: 3,
				}
			},
			"(max-width: 767px)": {
				slides: {
					perView: 2,
				}
			},
		},
		
	},
	[
		navigation,
		(slider) => {
			let timeout
			let mouseOver = false
			function clearNextTimeout() {
				clearTimeout(timeout)
			}
			function nextTimeout() {
				clearTimeout(timeout)
				if (mouseOver) return
				timeout = setTimeout(() => {
					slider.next()
				}, 2000)
			}
			slider.on("created", () => {
				slider.container.addEventListener("mouseover", () => {
					mouseOver = true
					clearNextTimeout()
				})
				slider.container.addEventListener("mouseout", () => {
					mouseOver = false
					nextTimeout()
				})
				nextTimeout()
			})
			slider.on("dragStarted", clearNextTimeout)
			slider.on("animationEnded", nextTimeout)
			slider.on("updated", nextTimeout)
		},
	]);
	
});

function navigation(slider) {
	
	let navigation_wrapper, arrowLeft, arrowRight

	function markup(remove) {
		wrapperMarkup(remove)
		arrowMarkup(remove)
	}

	function removeElement(elment) {
		elment.parentNode.removeChild(elment)
	}

	function createDiv(className) {
		var div = document.createElement("div")
		var classNames = className.split(" ")
		classNames.forEach((name) => div.classList.add(name))
		return div
	}

	function arrowMarkup(remove) {
		
		if (remove) {
			removeElement(arrowLeft)
			removeElement(arrowRight)
			return
		}
		
		arrowLeft = document.createElement('span');
		arrowLeft.classList.add('keen-slider-navigation-arrow');
		arrowLeft.classList.add('arrow--left');
		arrowLeft.addEventListener("click", () => slider.prev());
		
		arrowRight = document.createElement('span');
		arrowRight.classList.add('keen-slider-navigation-arrow');
		arrowRight.classList.add('arrow--right');
		arrowRight.addEventListener("click", () => slider.next());
		
		navigation_wrapper.appendChild(arrowLeft);
		navigation_wrapper.appendChild(arrowRight);
		
	}

	function wrapperMarkup(remove) {
		if (remove) {
			var parent = navigation_wrapper.parentNode
			while (navigation_wrapper.firstChild)
				parent.insertBefore(navigation_wrapper.firstChild, navigation_wrapper)
			removeElement(navigation_wrapper)
			return
		}
		if( slider.slides.length > 1 ) {
			navigation_wrapper = createDiv("keen-slider-navigation-wrapper")
			slider.container.parentNode.appendChild(navigation_wrapper)
		}
	}
	
	function updateClasses() {
        let loop = slider.options.loop;
		var slide = slider.track.details.rel
		slide === 0 && !loop ?
			arrowLeft.classList.add("arrow--disabled") :
			arrowLeft.classList.remove("arrow--disabled")
		slide === slider.track.details.slides.length - 1 && !loop ?
			arrowRight.classList.add("arrow--disabled") :
			arrowRight.classList.remove("arrow--disabled")
	}

	slider.on("created", () => {
		markup()
		updateClasses()
	})
	slider.on("optionsChanged", () => {
		markup(true)
		markup()
		updateClasses()
	})
	slider.on("slideChanged", () => {
		updateClasses()
	})
	slider.on("destroyed", () => {
		markup(true)
	})
	
}